// removed by extract-text-webpack-plugin
module.exports = {"alertMessageContainer":"alertMessageContainer___1Ou5m","alertMessageHeader":"alertMessageHeader___f14xD","vpAlertMessageRounded":"vpAlertMessageRounded___F8VyH","alertMesssageTitle":"alertMesssageTitle___1Ml3D","error":"error___3GAM5","success":"success___1rCXy","info":"info___1LEu0","warning":"warning___2tCGm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AlertMessage/alertMessage.module.less
// module id = 3777
// module chunks = 33